// ════════════════════════════════════════════════════════════════════════
// ResourceViewerPage.tsx — Visor genérico de documentos (PDF/HTML/galería)
// ════════════════════════════════════════════════════════════════════════
// Busca el recurso por :slug en resources.ts y lo muestra dentro del layout
// del dashboard. Los PDF y HTML se embeben en un iframe con un enlace de
// respaldo para abrir en pestaña nueva; las galerías muestran una grilla
// de imágenes.
// ════════════════════════════════════════════════════════════════════════

import { useParams, Link } from 'react-router-dom';
import { DashboardLayout } from '../layouts/DashboardLayout/DashboardLayout';
import { AppSidebarMenu } from '../components/AppSidebarMenu/AppSidebarMenu';
import { findResource } from '../data/resources';
import styles from './ResourceViewerPage.module.css';

export default function ResourceViewerPage() {
  const { slug } = useParams<{ slug: string }>();
  const resource = findResource(slug);

  return (
    <DashboardLayout.Root>
      <DashboardLayout.Sidebar>
        <AppSidebarMenu />
      </DashboardLayout.Sidebar>

      <DashboardLayout.Content>
        {!resource ? (
          <div className={styles.notFound}>
            <h1 className={styles.pageTitle}>Recurso no encontrado</h1>
            <p>No encontramos el documento solicitado.</p>
            <Link to="/dashboard/leads" className={styles.backLink}>
              Volver al panel
            </Link>
          </div>
        ) : (
          <>
            <div className={styles.pageHeader}>
              <div>
                <h1 className={styles.pageTitle}>{resource.title}</h1>
                <p className={styles.pageSubtitle}>{resource.description}</p>
              </div>
              {resource.file && (
                <a
                  className={styles.openLink}
                  href={resource.file}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Abrir en pestaña nueva ↗
                </a>
              )}
            </div>

            {resource.kind === 'gallery' ? (
              <div className={styles.gallery}>
                {resource.images?.map((img) => (
                  <figure key={img.file} className={styles.galleryItem}>
                    <img src={img.file} alt={img.caption} loading="lazy" />
                    <figcaption>{img.caption}</figcaption>
                  </figure>
                ))}
              </div>
            ) : (
              <div className={styles.viewerFrame}>
                <iframe title={resource.title} src={resource.file} />
              </div>
            )}
          </>
        )}
      </DashboardLayout.Content>
    </DashboardLayout.Root>
  );
}
